import { Loading } from '@Common/Loading';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { providerIcon } from 'appConstants';
import { capitalizeFirstLetter, classNames } from 'helpers/validation';
import { FormattedMessage } from 'react-intl';
import {
  useDeletePayment,
  useGetPaymentsList,
  useSetDefaultPayment,
} from 'store/subscription/actions';
import { PaymentType } from 'store/subscription/types';

interface PaymentRowProps {
  method: PaymentType;
}

export const PaymentRow = ({ method }: PaymentRowProps) => {
  const { data: paymentsMethod } = useGetPaymentsList();
  const { mutate: onDelete, isPending: isDeletePending } = useDeletePayment();
  const { mutate: onSetDefault, isPending: isDefaultSetPending } = useSetDefaultPayment();

  return (
    <>
      <div
        className={classNames(
          'p-5 rounded-lg  min-h-[56px] md:min-h-[156px] flex flex-col items-start justify-between relative',
          method.is_default ? 'bg-primary/10' : 'bg-gray-100',
        )}
      >
        {(paymentsMethod?.length || 0) > 1 && !method.is_default && (
          <button
            className="absolute right-2 top-2 rounded-full bg-white flex items-center justify-center w-5 h-5"
            onClick={() => {
              onDelete(method.id);
            }}
          >
            {isDeletePending ? <Loading /> : <XMarkIcon className="h-4 w-4" />}
          </button>
        )}

        {method.is_default ? (
          <div className="text-base truncate max-w-full flex items-center">
            <div className="mr-1">
              <CheckIcon className="h-4 w-4 text-primary" />
            </div>
            <div className="truncate">
              <FormattedMessage id="defaultCard" />
            </div>
          </div>
        ) : (
          <button
            onClick={() => {
              onSetDefault(method.id);
            }}
            className={classNames(
              'text-base truncate max-w-full text-primary md:hover:text-primary/80',
            )}
          >
            {isDefaultSetPending ? <Loading /> : <FormattedMessage id="makeAsDefault" />}
          </button>
        )}

        <div className="flex items-center w-full justify-between">
          <div className="flex flex-col">
            <div className="text-base">
              {capitalizeFirstLetter(method.card.brand || '')} ⋅⋅ {method.card.last4}
            </div>
            <div className="text-base flex items-center">
              <div className="truncate mr-2">
                <FormattedMessage id="expiration" />:{' '}
              </div>
              <div className="text-base whitespace-nowrap">
                {method.card.exp_month} / {method.card.exp_year}
              </div>
            </div>
          </div>

          <div>
            {providerIcon[method.card.brand?.toLowerCase() as keyof typeof providerIcon]
              ?.baseIcon || null}
          </div>
        </div>
      </div>
    </>
  );
};
